import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ProductAnalytics } from "../../features/analytics/ProductAnalytics.jsx";
import { PostValuePaywallShadow } from "../../features/billing/PostValuePaywallShadow.jsx";
import { NotificationsBell } from "../../features/notifications/NotificationsBell.jsx";
import { NotificationsProvider } from "../../features/notifications/NotificationsProvider.jsx";
import "../../features/notifications/notifications.css";
import { useWorkspaceTimeZone } from "../../features/profile/WorkspaceTimeZone.jsx";
import { timeZoneBadge } from "../../lib/dateTime.js";
import { MobileNav } from "./MobileNav.jsx";
import { PrimaryNav } from "./PrimaryNav.jsx";
import { PwaInstallHint } from "./PwaInstallHint.jsx";

export function AppShell() {
  const { timeZone } = useWorkspaceTimeZone();
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    globalThis.scrollTo?.({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <NotificationsProvider>
      <div className="app-frame">
        <ProductAnalytics />
        <PostValuePaywallShadow />
        <a className="skip-link" href="#main-content">
          Перейти к содержанию
        </a>
        <aside className="desktop-rail">
          <div className="brand-lockup" aria-label="AxonLeads">
            <span className="brand-lockup__name">AXONLEADS</span>
            <span className="brand-lockup__edition">Кабинет фрилансера</span>
          </div>
          <PrimaryNav />
          <div className="rail-foot">
            <span className="rail-foot__signal" aria-hidden="true" />
            <span>Часовой пояс</span>
            <span className="type-meta">{timeZoneBadge(timeZone)}</span>
          </div>
        </aside>
        <div className="workspace">
          <header className="mobile-head">
            <span className="brand-lockup__name">AXONLEADS</span>
            <span className="mobile-head__aside">
              <NotificationsBell />
            </span>
          </header>
          <main id="main-content" className="app-content" tabIndex="-1">
            <PwaInstallHint />
            <Outlet />
          </main>
        </div>
        <MobileNav />
      </div>
    </NotificationsProvider>
  );
}
